import { AbstractTrackedObject } from "./AbstractTrackedObject";
export class TrackedController extends AbstractTrackedObject {
    constructor(name, c, referencedObjectUid, threshold = 0.45) {
        super(name, threshold, referencedObjectUid);
        this.connected = true;
        this.controllerData = c;
    }
    get controllerUid() {
        return this.controllerData.uid;
    }
    /** Rebinds this tracked object to a (re)connected controller while keeping the collected statistics. */
    reconnect(c) {
        this.controllerData = c;
        this.connected = true;
    }
    disconnect() {
        this.connected = false;
        this.lastSpeed = 0;
        this.deactivate();
    }
    isAvailable() {
        return this.connected && this.controllerData.isTransformValid;
    }
    getPosition() {
        return this.controllerData.transform.position;
    }
    getOrientation() {
        return this.controllerData.transform.orientation;
    }
    getLinearVelocity() {
        return this.controllerData.transform.linearVelocity;
    }
}
